<ng-template #dashboardIconTemplate>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20px"
    height="18px"
    viewBox="0 0 20 18"
    version="1.1"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-111.000000, -104.000000)" fill="#BCE4FB">
        <g transform="translate(110.000000, 104.000000)">
          <path
            d="M11,0 C5.477,0 1,4.477 1,10 C1,13.277 2.582,16.177 5.018,18 L16.982,18 C19.418,16.177 21,13.277 21,10 C21,4.477 16.525,0 11,0 Z M11,13 C9.342,13 8,11.657 8,10 C8,8.344 9.342,7 11,7 C12.658,7 14,8.344 14,10 C14,11.657 12.658,13 11,13 Z M14.535,7.879 L13.121,6.464 L15.949,3.637 L17.363,5.05 L14.535,7.879 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #workQueuesIconTemplate>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20px"
    height="21px"
    viewBox="0 0 16 21"
    version="1.1"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-113.000000, -384.000000)" fill="#BCE4FB">
        <g transform="translate(110.000000, 104.000000)">
          <path
            d="M19,300.5 L19,282.5 L16,282.5 L16,285.5 L6,285.5 L6,282.5 L3,282.5 L3,300.5 L19,300.5 Z M5,290.5 L17,290.5 L17,288.5 L5,288.5 L5,290.5 Z M5,294.5 L17,294.5 L17,292.5 L5,292.5 L5,294.5 Z M5,298.5 L17,298.5 L17,296.5 L5,296.5 L5,298.5 Z M7,284.5 L15,284.5 L15,280.5 L7,280.5 L7,284.5 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #schedulingIconTemplate>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20px"
    height="19px"
    viewBox="0 0 20 19"
    version="1.1"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-111.000000, -143.000000)" fill="#BCE4FB">
        <g transform="translate(110.000000, 104.000000)">
          <path
            d="M16,41.7764 L16,39.7764 L14,39.7764 L14,41.7764 L8,41.7764 L8,39.7764 L6,39.7764 L6,41.7764 L1,41.7764 L1,57.7764 L21,57.7764 L21,41.7764 L16,41.7764 Z M4,54.7764 L6,54.7764 L6,52.7764 L4,52.7764 L4,54.7764 Z M4,50.7764 L6,50.7764 L6,48.7764 L4,48.7764 L4,50.7764 Z M8,54.7764 L10,54.7764 L10,52.7764 L8,52.7764 L8,54.7764 Z M8,50.7764 L10,50.7764 L10,48.7764 L8,48.7764 L8,50.7764 Z M12,54.7764 L14,54.7764 L14,52.7764 L12,52.7764 L12,54.7764 Z M12,50.7764 L14,50.7764 L14,48.7764 L12,48.7764 L12,50.7764 Z M16,54.7764 L18,54.7764 L18,52.7764 L16,52.7764 L16,54.7764 Z M16,50.7764 L18,50.7764 L18,48.7764 L16,48.7764 L16,50.7764 Z M4,46.7764 L18,46.7764 L18,44.7764 L4,44.7764 L4,46.7764 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #patientsIconTemplate>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20px"
    height="17px"
    viewBox="0 0 20 17"
    version="1.1"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-111.000000, -186.000000)" fill="#BCE4FB">
        <g transform="translate(110.000000, 104.000000)">
          <path
            d="M1,98.75 L21,98.75 L21,82.75 L1,82.75 L1,98.75 Z M3,96.75 C3,93.989 5.236,91.75 8,91.75 C6.342,91.75 5,90.407 5,88.75 C5,87.093 6.342,85.75 8,85.75 C9.658,85.75 11,87.093 11,88.75 C11,90.407 9.658,91.75 8,91.75 C10.764,91.75 13,93.989 13,96.75 L3,96.75 Z M13,90.75 L19,90.75 L19,88.75 L13,88.75 L13,90.75 Z M13,86.75 L19,86.75 L19,84.75 L13,84.75 L13,86.75 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #salesIconTemplate>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-111.000000, -224.000000)" fill="#BCE4FB">
        <g transform="translate(110.000000, 104.000000)">
          <path
            d="M7,124 L7,120 L1,120 L1,122 L5,122 L5,134 L19,134 L21,124 L7,124 Z M7,132 L9,132 L9,126 L7,126 L7,132 Z M11,132 L13,132 L13,126 L11,126 L11,132 Z M15,132 L17,132 L17,126 L15,126 L15,132 Z M17,138 C17,139.105 16.105,140 15,140 C13.895,140 13,139.105 13,138 C13,136.896 13.895,136 15,136 C16.105,136 17,136.896 17,138 Z M9,138 C9,139.105 8.105,140 7,140 C5.895,140 5,139.105 5,138 C5,136.896 5.895,136 7,136 C8.105,136 9,136.896 9,138 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #claimsIconTemplate>
  <svg
    width="24px"
    height="21px"
    viewBox="0 0 18 21"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Sidebar-icons"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="WSA-Claims-Icon1-1a"
        transform="translate(-26.000000, -291.000000)"
        fill="#BCE4FB"
        fill-rule="nonzero"
      >
        <g id="claim" transform="translate(26.000000, 291.000000)">
          <path
            d="M3.19190094,0.757189453 L0.801721698,3.06567187 C0.64859434,3.21357422 0.757018868,3.46655859 0.973528302,3.46655859 L3.36370755,3.46655859 C3.4979434,3.46651758 3.60675,3.36139453 3.60675,3.23170312 L3.60675,0.923261719 C3.60675,0.714082031 3.34498585,0.609328125 3.19190094,0.757189453 Z"
            id="Path"
          ></path>
          <path
            d="M13.8405566,12.9966211 C11.5567217,12.9966211 9.69868868,14.791752 9.69868868,16.9982695 C9.69868868,19.2047871 11.5567217,20.999959 13.8405566,20.999959 C16.1243915,20.999959 17.982467,19.2048281 17.982467,16.9982695 C17.9825094,14.791752 16.124434,12.9966211 13.8405566,12.9966211 Z M13.2023632,15.072219 C13.2023632,14.6457367 13.4881132,14.3 13.8405991,14.3 C14.1930849,14.3 14.4788349,14.6457367 14.4788349,15.072219 L14.4788349,17.027781 C14.4788349,17.4542633 14.1930849,17.8 13.8405991,17.8 C13.4881132,17.8 13.2023632,17.4542633 13.2023632,17.027781 L13.2023632,15.072219 Z M14.4755236,19.077209 C14.4734009,19.0973477 14.4704717,19.1174863 14.466184,19.1372148 C14.4623632,19.1569434 14.4568019,19.1766719 14.4508585,19.1955801 C14.4449151,19.2148984 14.4376557,19.2338066 14.4300566,19.2523047 C14.4219906,19.2708027 14.413033,19.2893008 14.4032689,19.3069785 C14.3935047,19.3246562 14.3828491,19.342334 14.3713443,19.3587812 C14.3597972,19.3756387 14.3471038,19.3920859 14.3338585,19.4077129 C14.3206557,19.4233398 14.3066462,19.4385566 14.2917877,19.452502 C14.2773113,19.4668984 14.2615613,19.4804746 14.2454292,19.4935996 C14.2292123,19.5059453 14.2122311,19.51825 14.194783,19.5293652 C14.1777594,19.5404805 14.1594623,19.5507344 14.1411651,19.560209 C14.1228255,19.5696836 14.1037217,19.5782969 14.0845755,19.5860898 C14.0654292,19.5938828 14.0458585,19.6004863 14.0258632,19.6062285 C14.0058255,19.6123809 13.9858726,19.6173437 13.9654528,19.6210352 C13.945033,19.6251367 13.9241462,19.628418 13.9033443,19.6300996 C13.8825,19.6321504 13.8616557,19.6333809 13.8407689,19.6333809 C13.819967,19.6333809 13.7986981,19.6321504 13.7778538,19.6300996 C13.757434,19.628459 13.7365896,19.6251777 13.7161698,19.6210352 C13.69575,19.6173437 13.6753302,19.6124219 13.6553349,19.6062285 C13.6352972,19.6004863 13.6157264,19.5938828 13.5966226,19.5860898 C13.5774764,19.5782969 13.5583302,19.5696426 13.540033,19.560209 C13.5216934,19.5507344 13.5038208,19.5404805 13.4863726,19.5293652 C13.468967,19.51825 13.4519009,19.5059453 13.4361509,19.4935996 C13.4195519,19.4804336 13.4042264,19.4668984 13.3893679,19.452502 C13.3744245,19.4385156 13.3603726,19.4232988 13.3472547,19.4077129 C13.3340094,19.3920859 13.3217406,19.3756387 13.3102358,19.3587812 C13.2983066,19.342334 13.2876934,19.3246562 13.2778868,19.3069785 C13.2680802,19.2893008 13.2591651,19.2708027 13.2515236,19.2523047 C13.2434575,19.2338066 13.2361981,19.2148984 13.2302547,19.1955801 C13.2243113,19.1766719 13.2191745,19.1569434 13.2149292,19.1372148 C13.210684,19.1174863 13.2077123,19.0973477 13.2055472,19.077209 C13.2033821,19.0570703 13.2025755,19.0369316 13.2025755,19.016793 C13.2025755,18.9966543 13.203467,18.9761055 13.2055472,18.9559668 C13.2076698,18.9362383 13.2106415,18.9160996 13.2149292,18.8963711 C13.219217,18.8766426 13.2243113,18.8569141 13.2302547,18.8375957 C13.2361981,18.8186875 13.2434575,18.7993691 13.2515236,18.7808711 C13.2591651,18.762373 13.2681226,18.743875 13.2778868,18.7261973 C13.2876085,18.7085195 13.2982642,18.691252 13.3102358,18.6743945 C13.321783,18.6575371 13.3340519,18.6410898 13.3472547,18.625873 C13.3604575,18.6102461 13.374467,18.5950293 13.3893679,18.5806738 C13.4042689,18.5666875 13.4195943,18.5527012 13.4361509,18.5399863 C13.4519009,18.5272305 13.468967,18.5153359 13.4863726,18.5042207 C13.5038208,18.4931055 13.5216934,18.4824414 13.540033,18.4729668 C13.5583302,18.4634922 13.5774764,18.4548789 13.5966226,18.4474961 C13.6157264,18.4397031 13.6352972,18.4326895 13.6553349,18.4269473 C13.6753302,18.4212051 13.6957075,18.4162422 13.7161698,18.4121406 C13.7366321,18.4080391 13.757434,18.405168 13.7778538,18.4030762 C13.8195,18.3989746 13.8616557,18.3989746 13.9033868,18.4030762 C13.9241887,18.405127 13.945033,18.407998 13.9654953,18.4121406 C13.9858726,18.4162422 14.0058679,18.4212051 14.0259057,18.4269473 C14.0459009,18.4326895 14.0654717,18.4397031 14.0846179,18.4474961 C14.1037642,18.4548789 14.1228679,18.4635332 14.1412075,18.4729668 C14.1595047,18.4824414 14.1777594,18.4931055 14.1948255,18.5042207 C14.2122736,18.5153359 14.2292972,18.5272305 14.2454717,18.5399863 C14.2616462,18.5527422 14.2773962,18.5666875 14.2918302,18.5806738 C14.3067311,18.5950703 14.320783,18.6102871 14.3339009,18.625873 C14.3471462,18.6410898 14.3598396,18.6575371 14.3713868,18.6743945 C14.3828915,18.691252 14.3935047,18.7085195 14.4033113,18.7261973 C14.413033,18.743875 14.4219906,18.762373 14.4300991,18.7808711 C14.4377406,18.7993691 14.445,18.8186875 14.4509009,18.8375957 C14.4568868,18.8569141 14.4624481,18.8766426 14.4662264,18.8963711 C14.4705142,18.9160996 14.4734434,18.9362383 14.475566,18.9559668 C14.4777311,18.9761055 14.4789623,18.9966543 14.4789623,19.016793 C14.4789623,19.0369316 14.4776887,19.0570703 14.4755236,19.077209 Z"
            id="Shape"
          ></path>
          <path
            d="M12.6795142,0 L5.12626415,0 C4.9920283,0 4.8832217,0.105123047 4.8832217,0.234814453 L4.8832217,4.05443555 C4.8832217,4.05927539 4.88258491,4.06399219 4.88245755,4.06879102 C4.88258491,4.07358984 4.8832217,4.07830664 4.8832217,4.08314648 C4.8832217,4.42369922 4.5974717,4.69977539 4.24498585,4.69977539 L0.260533019,4.69977539 C0.12629717,4.69977539 0.017490566,4.80489844 0.017490566,4.93458984 L0.017490566,16.4355762 C0.017490566,17.3956699 0.823075472,18.1739824 1.81681132,18.1739824 L8.52350943,18.1739824 C8.80204245,18.1739824 9.01188679,17.9289551 8.95882075,17.6648145 C8.89900472,17.366959 8.86767453,17.0592598 8.86767453,16.7445059 C8.86767453,14.091 11.0941132,12.1454648 13.8405991,12.1454648 C13.9010094,12.1454648 13.9611651,12.1464902 14.021066,12.148582 C14.2714528,12.1572363 14.4787925,11.9625352 14.4787925,11.7204199 L14.4787925,1.73840625 C14.4787925,0.7783125 13.67325,0 12.6795142,0 Z M6.4575,14.6319141 L3.21028302,14.6319141 C2.85779717,14.6319141 2.57204717,14.3558379 2.57204717,14.0152852 C2.57204717,13.6747324 2.85779717,13.3986563 3.21028302,13.3986563 L6.4575,13.3986563 C6.80998585,13.3986563 7.09573585,13.6747324 7.09573585,14.0152852 C7.09573585,14.3558379 6.80998585,14.6319141 6.4575,14.6319141 Z M11.2860849,12.1772109 L3.21024057,12.1772109 C2.85775472,12.1772109 2.57200472,11.9011348 2.57200472,11.560582 C2.57200472,11.2200293 2.85775472,10.9439531 3.21024057,10.9439531 L11.2860849,10.9439531 C11.6385708,10.9439531 11.9243208,11.2200293 11.9243208,11.560582 C11.9243208,11.9011348 11.6385283,12.1772109 11.2860849,12.1772109 Z M11.2860849,9.70359961 L3.21024057,9.70359961 C2.85775472,9.70359961 2.57200472,9.42752344 2.57200472,9.0869707 C2.57200472,8.74641797 2.85775472,8.4703418 3.21024057,8.4703418 L11.2860849,8.4703418 C11.6385708,8.4703418 11.9243208,8.74641797 11.9243208,9.0869707 C11.9243208,9.42752344 11.6385283,9.70359961 11.2860849,9.70359961 Z M11.2860849,7.32498047 L3.21024057,7.32498047 C2.85775472,7.32498047 2.57200472,7.0489043 2.57200472,6.70835156 C2.57200472,6.36779883 2.85775472,6.09172266 3.21024057,6.09172266 L11.2860849,6.09172266 C11.6385708,6.09172266 11.9243208,6.36779883 11.9243208,6.70835156 C11.9243208,7.0489043 11.6385283,7.32498047 11.2860849,7.32498047 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #paymentTerminalIconTemplate>
  <div class="payment-terminal">
    <i class="fa fa-usd"></i>
  </div>
</ng-template>
<ng-template #billingIconTemplate>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20px"
    height="19px"
    viewBox="0 0 20 19"
    version="1.1"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-111.000000, -263.000000)" fill="#BCE4FB">
        <g transform="translate(110.000000, 104.000000)">
          <path
            d="M19,175.5 L19,159.5 L17,161.5 L15,159.5 L13,161.5 L11,159.5 L9,161.5 L7,159.5 L5,161.5 L3,159.5 L3,175.5 L1,175.5 L1,177.5 L21,177.5 L21,175.5 L19,175.5 Z M11,166.5 L17,166.5 L17,164.5 L11,164.5 L11,166.5 Z M11,170.5 L17,170.5 L17,168.5 L11,168.5 L11,170.5 Z M5,168.5 L8,168.5 L8,167.5 L5,167.5 L5,164.5 L6.5,164.5 L6.5,163.5 L7.5,163.5 L7.5,164.5 L9,164.5 L9,165.5 L6,165.5 L6,166.5 L9,166.5 L9,169.5 L7.5,169.5 L7.5,170.5 L6.5,170.5 L6.5,169.5 L5,169.5 L5,168.5 Z M5,174.5 L17,174.5 L17,172.5 L5,172.5 L5,174.5 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #catalogIconTemplate>
  <svg
    width="21px"
    height="19px"
    viewBox="0 0 15 19"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Sidebar-icons"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="WSA-Sidebar-Icons-1"
        transform="translate(-26.000000, -332.000000)"
        fill="#BCE4FB"
        fill-rule="nonzero"
      >
        <g id="catalog" transform="translate(26.000000, 332.000000)">
          <path
            d="M14.2017792,0.5 L0.798220781,0.5 C0.357395783,0.5 0,0.854858413 0,1.29255372 L0,17.7074463 C0,18.1451416 0.357395783,18.5 0.798220781,18.5 L14.2017792,18.5 C14.6426042,18.5 15,18.1451416 15,17.7074463 L15,1.29255373 C15,0.854858413 14.6426042,0.5 14.2017792,0.5 Z M5.1284633,14.3084839 L3.66214484,16.3112915 C3.56455254,16.4444458 3.4101974,16.5247559 3.24444544,16.5287109 C3.24024077,16.5288208 3.23614677,16.5288208 3.23205277,16.5288208 C3.07083741,16.5288208 2.91814198,16.4562012 2.81700895,16.3307373 L2.1935027,15.5576294 C2.00993626,15.3298828 2.04700363,14.9976563 2.27626804,14.8156128 C2.50553244,14.6333496 2.84013455,14.6701538 3.02347968,14.8976807 L3.07039479,14.9557983 L3.21158274,15.1309204 L4.2682792,13.6877563 C4.44089139,13.4518799 4.77339117,13.399585 5.01095424,13.5711914 C5.24851732,13.7425781 5.3010755,14.0726074 5.1284633,14.3084839 L5.1284633,14.3084839 Z M5.1284633,10.6444336 L3.66214484,12.6472412 C3.56455254,12.7803955 3.41008676,12.8607056 3.24444544,12.8645508 C3.24024077,12.8647705 3.23614677,12.8647705 3.23205277,12.8647705 C3.07083741,12.8647705 2.91803134,12.7919312 2.81700895,12.666687 L2.1935027,11.8933594 C2.00993626,11.6658325 2.04700363,11.3336059 2.27637868,11.1513428 C2.50553244,10.9691895 2.84013455,11.0059937 3.02370099,11.2336304 L3.07050546,11.291748 L3.21180403,11.4668701 L4.2682792,10.0234863 C4.44111271,9.78771971 4.77339117,9.73553467 5.01106488,9.90692139 C5.24851732,10.078418 5.3010755,10.4085571 5.1284633,10.6444336 Z M5.1284633,6.98016358 L3.66214484,8.98308107 C3.56455254,9.11623534 3.41008676,9.19665529 3.24444544,9.20039062 C3.24024077,9.20050048 3.23614677,9.20050048 3.23205277,9.20050048 C3.07083741,9.20050048 2.91803134,9.12788086 2.81700895,9.00263672 L2.1935027,8.22930907 C2.00993626,8.00178221 2.04700363,7.66955565 2.27637868,7.48729249 C2.50553244,7.3050293 2.84013455,7.34194336 3.02370099,7.56947022 L3.07050546,7.62769775 L3.21180403,7.80270997 L4.2682792,6.35943603 C4.44111271,6.12366944 4.77339117,6.07148437 5.01106488,6.24287109 C5.24851732,6.41425781 5.3010755,6.74439697 5.1284633,6.98016358 L5.1284633,6.98016358 Z M5.1284633,3.31611328 L3.66214484,5.31892091 C3.56455254,5.45207518 3.4101974,5.53249513 3.24444544,5.53623047 C3.24024077,5.53645018 3.23614677,5.53645018 3.23205277,5.53645018 C3.07083741,5.53645018 2.91814198,5.4637207 2.81700895,5.33847656 L2.1935027,4.56525878 C2.00993626,4.33762206 2.04700363,4.00550538 2.27626804,3.82324219 C2.50553244,3.640979 2.84013455,3.6777832 3.02347968,3.90541992 L3.07039479,3.96342773 L3.21158274,4.13865968 L4.2682792,2.69538576 C4.44089139,2.45961914 4.77339117,2.40732422 5.01095424,2.57871094 C5.24851732,2.75009766 5.3010755,3.08034669 5.1284633,3.31611328 Z M12.7188634,16 L6.97198373,16 L6.97198373,14 L12.7188634,14 L12.7188634,16 Z M12.7188634,12 L6.97198373,12 L6.97198373,10 L12.7188634,10 L12.7188634,12 Z M12.7188634,8.5 L6.97198373,8.5 L6.97198373,6.5 L12.7188634,6.5 L12.7188634,8.5 Z M12.7188634,5 L6.97198373,5 L6.97198373,3 L12.7188634,3 L12.7188634,5 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #inventoryIconTemplate>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    version="1.1"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-110.000000, -303.000000)" fill="#BCE4FB">
        <g transform="translate(110.000000, 104.000000)">
          <path
            d="M6.5,210.5 L9.5,210.5 L9.5,219.5 L0.5,219.5 L0.5,210.5 L3.5,210.5 L3.5,213.5 L6.5,213.5 L6.5,210.5 Z M12,199.5 L15,199.5 L15,208.5 L6,208.5 L6,199.5 L9,199.5 L9,202.5 L12,202.5 L12,199.5 Z M17.5,210.5 L20.5,210.5 L20.5,219.5 L11.5,219.5 L11.5,210.5 L14.5,210.5 L14.5,213.5 L17.5,213.5 L17.5,210.5 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #marketingIconTemplate>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="21px"
    height="19px"
    viewBox="0 0 21 19"
    version="1.1"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-110.000000, -345.000000)" fill="#BCE4FB">
        <g transform="translate(110.000000, 104.000000)">
          <path
            d="M20.5,241.5 L8.5,245.5 L0.5,245.5 L0.5,253.5 L4.5,253.5 L6.5,259.5 L10.5,259.5 L8.5,253.5 L20.5,257.5 L20.5,241.5 Z M13.5,252.5 L18.5,252.5 L18.5,250.5 L13.5,250.5 L13.5,252.5 Z M13.5,248.5 L18.5,248.5 L18.5,246.5 L13.5,246.5 L13.5,248.5 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #outreachIconTemplate>
  <svg
    width="21px"
    height="19px"
    viewBox="0 0 19 19"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Sidebar-icons"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="WSA-Sidebar-Icons-1"
        transform="translate(-24.000000, -451.000000)"
        fill="#BCE4FB"
        fill-rule="nonzero"
      >
        <g id="outreach" transform="translate(24.000000, 451.000000)">
          <path
            d="M18.7500769,3.87390909 L16.416,6.19681818 L14.6688221,6.19681818 L13.7118798,6.19681818 L13.2852933,6.62136364 L11.6627115,8.23618182 L10.6516923,9.24236364 L9.79678365,10.0931818 C9.66889904,10.2204545 9.50137019,10.2840909 9.33375,10.2840909 C9.16000962,10.2840909 8.98608654,10.2156364 8.85664904,10.0788182 C8.61083654,9.819 8.63659615,9.40454545 8.89008173,9.15218182 L10.5910385,7.45936364 L10.7212981,7.32972727 L10.7212981,7.32972727 L12.3509135,5.70790909 L12.3509135,5.70790909 L12.7857212,5.27518182 L12.7857212,4.34736364 L12.7857212,2.584 L13.5927644,1.78081818 L13.5927644,1.78081818 L15.1197981,0.261090909 C15.1399856,0.241 15.1611779,0.223454545 15.1828269,0.207090909 C15.1880337,0.203181818 15.193149,0.199363636 15.1984471,0.195636364 C15.2200962,0.180363636 15.2422019,0.166272727 15.2648558,0.154454545 C15.2666827,0.153454545 15.268601,0.152818182 15.2705192,0.151818182 C15.2919856,0.141 15.3138173,0.131909091 15.3359231,0.124 C15.3414952,0.122 15.346976,0.12 15.3525481,0.118181818 C15.376024,0.110636364 15.399774,0.104272727 15.4237067,0.0999090909 C15.4269952,0.0992727273 15.430375,0.0990909091 15.4336635,0.0984545455 C15.4552212,0.0949090909 15.4767788,0.0927272727 15.4984279,0.0916363636 C15.504,0.0913636364 15.5094808,0.091 15.5150529,0.0908181818 C15.5391683,0.0903636364 15.5631923,0.0910909091 15.5870337,0.0935454545 C15.5909615,0.094 15.5948894,0.0947272727 15.5988173,0.0951818182 C15.6194615,0.0977272727 15.6400144,0.101454545 15.6602019,0.106181818 C15.6658654,0.107545455 15.6716202,0.108727273 15.6772837,0.110181818 C15.7003942,0.116272727 15.7232308,0.123454545 15.7453365,0.132181818 C15.748625,0.133454545 15.7517308,0.135090909 15.7549279,0.136363636 C15.7743846,0.144454545 15.7932933,0.153636364 15.8117452,0.163727273 C15.8170433,0.166636364 15.8223413,0.169454545 15.8274567,0.172454545 C15.848101,0.184545455 15.8681971,0.197545455 15.8872885,0.212 C15.8895721,0.213727273 15.8916731,0.215727273 15.8938654,0.217454545 C15.9108558,0.230818182 15.927024,0.245181818 15.9425529,0.260454545 C15.9469375,0.264727273 15.9513221,0.269 15.955524,0.273454545 C15.9722404,0.291 15.988226,0.309272727 16.00275,0.329 C16.0039375,0.330636364 16.0049423,0.332454545 16.0062212,0.334181818 C16.0194663,0.352636364 16.0313413,0.372090909 16.0423942,0.392272727 C16.0454087,0.397818182 16.0484231,0.403363636 16.0512548,0.409090909 C16.0624904,0.431454545 16.0729038,0.454545455 16.0812163,0.478909091 C16.0815817,0.480090909 16.0818558,0.481272727 16.0822212,0.482454545 C16.0900769,0.505818182 16.0960144,0.530181818 16.1008558,0.555181818 C16.1021346,0.561818182 16.1033221,0.568545455 16.1044183,0.575272727 C16.1086202,0.602 16.1118173,0.629272727 16.1124567,0.657727273 L16.1593173,2.83918182 L16.2061779,2.84018182 L18.3511683,2.88581818 C18.4669038,2.88827273 18.5682981,2.92281818 18.6531587,2.97727273 C18.6855865,2.99809091 18.7163702,3.02081818 18.7435,3.04718182 C18.7826875,3.08536364 18.8161202,3.12872727 18.842976,3.17572727 C18.8698317,3.22272727 18.8902933,3.27327273 18.9035385,3.32572727 C18.9500337,3.50954545 18.9085625,3.71627273 18.7500769,3.87390909 Z M9.21819712,4.65590909 C6.35942788,4.65590909 4.03357212,6.97063636 4.03357212,9.81572727 C4.03357212,12.6608182 6.35942788,14.9755455 9.21819712,14.9755455 C12.0769663,14.9755455 14.4028221,12.6608182 14.4028221,9.81572727 C14.4028221,9.11390909 14.2600481,8.44518182 14.0036394,7.835 L12.1300385,9.69963636 C12.1315913,9.73836364 12.1343317,9.77672727 12.1343317,9.81581818 C12.1343317,11.4161818 10.8261635,12.7180909 9.21810577,12.7180909 C7.61004808,12.7180909 6.30187981,11.4160909 6.30187981,9.81581818 C6.30187981,8.22109091 7.60109615,6.92309091 9.20129808,6.914 L11.1114375,5.013 C10.5247212,4.78281818 9.88612019,4.65590909 9.21819712,4.65590909 Z M17.3848173,7.16109091 C17.1278606,7.41681818 16.779375,7.56045455 16.4159087,7.56045455 L15.3676202,7.56045455 C15.6290529,8.26363636 15.7730144,9.02309091 15.7730144,9.81563636 C15.7730144,13.4127273 12.8325817,16.3390909 9.21819712,16.3390909 C5.6038125,16.3390909 2.66337981,13.4127273 2.66337981,9.81563636 C2.66337981,6.21854545 5.6038125,3.29218182 9.21819712,3.29218182 C9.98897596,3.29218182 10.7283317,3.42663636 11.4155288,3.67136364 L11.4155288,2.584 C11.4155288,2.22236364 11.5598558,1.87545455 11.8168125,1.61972727 L12.25025,1.18836364 C11.300524,0.856818182 10.2802788,0.675636364 9.21810577,0.675636364 C4.15405769,0.675727273 0.0341634615,4.77590909 0.0341634615,9.81572727 C0.0341634615,14.8555455 4.15414904,18.9558182 9.21819712,18.9558182 C14.2822452,18.9558182 18.4022308,14.8555455 18.4022308,9.81572727 C18.4022308,8.721 18.2071154,7.671 17.850774,6.69745455 L17.3848173,7.16109091 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #reportsIconTemplate>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20px"
    height="21px"
    viewBox="0 0 16 21"
    version="1.1"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-113.000000, -384.000000)" fill="#BCE4FB">
        <g transform="translate(110.000000, 104.000000)">
          <path
            d="M19,300.5 L19,282.5 L16,282.5 L16,285.5 L6,285.5 L6,282.5 L3,282.5 L3,300.5 L19,300.5 Z M5,290.5 L17,290.5 L17,288.5 L5,288.5 L5,290.5 Z M5,294.5 L17,294.5 L17,292.5 L5,292.5 L5,294.5 Z M5,298.5 L17,298.5 L17,296.5 L5,296.5 L5,298.5 Z M7,284.5 L15,284.5 L15,280.5 L7,280.5 L7,284.5 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #adminIconTemplate>
  <svg
    width="19px"
    height="18px"
    viewBox="0 0 19 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-21.000000, -656.000000)" fill="#BDE1ED">
        <g transform="translate(0.000000, 85.000000)">
          <g>
            <g transform="translate(21.000000, 571.000000)">
              <path
                d="M9.5,12.5 C7.567,12.5 6,10.934 6,9 C6,7.066 7.567,5.5 9.5,5.5 C11.434,5.5 13,7.066 13,9 C13,10.934 11.434,12.5 9.5,12.5 Z M17,9 C17,8.716 16.981,8.438 16.95,8.163 L18.795,7.098 L15.794,1.901 L13.945,2.969 C13.498,2.638 13.016,2.352 12.5,2.128 L12.5,0 L6.5,0 L6.5,2.128 C5.984,2.354 5.502,2.639 5.054,2.969 L3.205,1.902 L0.205,7.099 L2.049,8.164 C2.019,8.438 2,8.717 2,9 C2,9.283 2.019,9.563 2.05,9.837 L0.205,10.902 L3.205,16.098 L5.054,15.03 C5.502,15.361 5.984,15.646 6.5,15.872 L6.5,18 L12.5,18 L12.5,15.872 C13.016,15.646 13.498,15.362 13.945,15.031 L15.794,16.099 L18.794,10.902 L16.95,9.838 C16.981,9.563 17,9.284 17,9 Z"
                id="Fill-3"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>

<!-- BEGIN SIDEBAR-->
<nav
  class="page-sidebar"
  #pageSidebar
  *ngIf="isSidebarVisible && hasMenuPermissions"
  [ngClass]="{ open: isSidebarOpen, pinned: isSidebarPinned }"
>
<div class="row burger-container">
  <div class="pin-button-holder">
    <img
      (click)="onMenuToggleButtonClicked()"
      width="21px"
      height="17px"
      src="./assets/images/icons/nav/burger.svg"
    />
    
    <img class="menu-logo" [src]="imagesService.logo" (error)="hideImage('logo')"
      (click)="onLogoClick()"
    />
  </div>
  <!-- <div class="menu-logo" *ngIf="isSidebarOpen">
    <img [src]="imagesService.logo" (error)="hideImage('logo')" />
  </div> -->
</div>
  <div
    class="page-sidebar-menu"
    (mouseenter)="onSidebarMouseEnter()"
    (mouseleave)="onSidebarMouseLeave()"
  >
    <perfect-scrollbar>
      <div class="sidebar-menu">
        <!-- BEGIN SIDEBAR MENU ITEMS-->
        <ul class="main-menu">
          <li
            *ngFor="let item of menuNodes"
            routerLinkActive="selected"
            [hidden]="!item.isVisible"
            [class.open]="
              item.children &&
              item == openedMainNode &&
              !isOpenedMainNodeCollapsed
            "
          >
            <ng-template [ngIf]="item.children">
              <div
                class="main-node-wrapper has-children"
                (click)="navigate($event, item)"
              >
                <span class="icon-thumbnail">
                  <ng-container *ngIf="that[item.icon]">
                    <ng-container
                      [ngTemplateOutlet]="that[item.icon]"
                    ></ng-container>
                  </ng-container>
                </span>
                <span class="title">{{ item.title | translate }}</span>
                <span
                  class="arrow"
                  [class.open]="
                    item == openedMainNode && !isOpenedMainNodeCollapsed
                  "
                ></span>
              </div>
            </ng-template>
            <ng-template [ngIf]="!item.children && !item.isAbsoluteUrl">
              <div class="main-node-wrapper">
                <div
                  class="main-node-wrapper has-children"
                  [routerLink]="item.link"
                  (click)="navigate($event, item)"
                >
                  <span class="icon-thumbnail">
                    <ng-container *ngIf="that[item.icon]">
                      <ng-container
                        [ngTemplateOutlet]="that[item.icon]"
                      ></ng-container>
                    </ng-container>
                  </span>
                  <span class="title">{{ item.title | translate }}</span>
                </div>
              </div>
            </ng-template>
            <ng-template
              [ngIf]="!item.children && item.isAbsoluteUrl && item.link"
            >
              <div class="main-node-wrapper">
                <a [href]="item.link" target="_blank">
                  <span class="icon-thumbnail">
                    <ng-container *ngIf="that[item.icon]">
                      <ng-container
                        [ngTemplateOutlet]="that[item.icon]"
                      ></ng-container>
                    </ng-container>
                  </span>
                  <span class="title">{{ item.title | translate }}</span>
                </a>
              </div>
            </ng-template>
            <ul class="sub-menu">
              <li
                *ngFor="let child of item.children"
                [class.selected]="child.isSelected"
                [routerLinkActive]="item.rootPath && !rootPathToExclude?.includes(item.rootPath) ? 'selected' : ''"
                [hidden]="!child.isVisible"
                [attr.data-menu-quantity-item]="child.quantityType"
              >
                <a [routerLink]="child.link">
                  <span class="abbreviation-and-quantity-wrapper">
                    <span class="abbreviation">{{
                      child.abbreviation | translate
                    }}</span>
                    <span
                      class="badge badge-success"
                      *ngIf="child.quantityType"
                      >{{ child.quantityType === workQueue ? workQueueMenuQuantities[child.id] || 0 : menuQuantities[child.quantityType] }}</span
                    >
                  </span>
                  <span class="title">{{ child.title | translate }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <div class="version-container">
          <span class="version">v. {{ version }}.{{ build }}</span>
        </div>
        <div class="clearfix"></div>
      </div>
    </perfect-scrollbar>
  </div>
  <!-- START SIDEBAR MENU -->
  <!-- END SIDEBAR MENU -->
</nav>
<!-- END SIDEBAR -->
